import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import hcMap from 'highcharts/modules/map';
import proj4 from 'proj4';
import mapDataUSA from '@highcharts/map-collection/countries/us/us-all.geo.json';
import { customWrapper } from '../../../utility';
hcMap(Highcharts);
customWrapper(Highcharts);

function USAMapBubbleChart(props) {
    const { chartOptions, seriesData = [] } = props;
    const [updatedChartOptions, setUpdatedChartOptions] = useState({
        ...chartOptions,
        chart: {
            ...chartOptions.chart,
            proj4: proj4
        },
        series: [
            {
                // Use the gb-all map with no data as a basemap
                name: 'US Map',
                mapData: mapDataUSA,
                borderColor: '#FFFFFF',
                nullColor: '#E4E7EC',
                showInLegend: false,
                states: {
                    hover: {
                        color: null,
                        borderColor: null
                    }
                }
            },
            {
                // Specify points using lat/lon
                type: 'mapbubble',
                name: 'Locations',
                states: {
                    hover: {
                        color: null,
                        borderColor: null
                    }
                },
                color: '#DB97D2',
                data: [...seriesData],
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
                            console.log(this.keyword);
                        }
                    }
                },
                minSize: seriesData.length === 2 ? 25 : 40,
                maxSize: seriesData.length === 2 ? 50 : undefined
            }
        ]
    });

    useEffect(() => {
        if (seriesData.length > 0) {
            setUpdatedChartOptions({
                ...chartOptions,
                series: [
                    {
                        // Use the gb-all map with no data as a basemap
                        name: 'US Map',
                        mapData: mapDataUSA,
                        borderColor: '#FFFFFF',
                        nullColor: '#E4E7EC',
                        showInLegend: false,
                        states: {
                            hover: {
                                color: null,
                                borderColor: null
                            }
                        }
                    },
                    {
                        // Specify points using lat/lon
                        type: 'mapbubble',
                        name: 'Locations',
                        states: {
                            hover: {
                                color: null,
                                borderColor: null
                            }
                        },
                        color: '#DB97D2',
                        data: [...seriesData],
                        cursor: 'pointer',
                        point: {
                            events: {
                                click: function () {
                                    console.log(this.keyword);
                                }
                            }
                        },
                        minSize: seriesData.length === 2 ? 40 : 40,
                        maxSize: seriesData.length === 2 ? 50 : undefined
                    }
                ]
            });
        }
    }, [chartOptions, seriesData]);

    return (
        <HighchartsReact
            constructorType={'mapChart'}
            containerProps={{ style: { height: 'auto', width: '100%' } }}
            highcharts={Highcharts}
            options={updatedChartOptions}
        />
    );
};

export default USAMapBubbleChart;
